import React, { useEffect, useState } from "react"
import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'
import { Link } from "react-router-dom"
import { Modal, Dropdown } from 'react-bootstrap'
import PaymentModal from '../../../components/PaymentModal'

import FilterSearch from 'pages/parts/FilterSearch'
import FilterPagination from 'pages/parts/FilterPagination'

import { httpOk, GET, POST } from 'helpers/api'
import { formatDate, formatMoney, returnSign, regexPhoneNumber } from 'helpers/helpers'

function Index() {
	const { t } = useTranslation()

	const date = new Date()

	/* Ta'minotchi qarzini tuzatish — tovarsiz sof moliyaviy amal. Backend ham
	   shu ro'yxatni tekshiradi (SupplierController::canAdjustSupplier) — bu yerdagisi
	   faqat tugmani ko'rsatmaslik uchun. */
	const reduxAccount = useSelector(state => state.account)
	const canAdjust = ['ROLE_OWNER', 'ROLE_DIRECTOR', 'ROLE_ADMIN'].includes(reduxAccount.role)

	const [data, setData] = useState([])

	const [modalPayment, setModalPayment] = useState(false)
	const [modalWriteOff, setModalWriteOff] = useState(false)
	const [modalAdjustment, setModalAdjustment] = useState(false)
	const [selectedItem, setSelectedItem] = useState({ 'created_at': date })
	const [filterDataExist, setFilterDataExist] = useState(false)
	const [filterData, setFilterData] = useState({})
	const [pagination, setPagination] = useState({
		url: `/report-suppliers`,
		response: null
	})

	async function searchWithFilter() {
		var filterUrl = `/report-suppliers`
		var urlParams = ""
		checkFilter()

		if (filterData.search)
			urlParams += returnSign(urlParams) + 'search=' + filterData.search
		if (filterData.page)
			urlParams += returnSign(urlParams) + 'page=' + filterData.page
		if (filterData.size)
			urlParams += returnSign(urlParams) + 'size=' + filterData.size

		if (`/report-suppliers${urlParams}` !== filterUrl)
			setFilterDataExist(true)

		filterUrl = filterUrl + urlParams

		const response = await GET(filterUrl, {}, { loader: true })
		if (httpOk(response)) {
			setData(response.data)
			setPagination({ ...pagination, 'url': filterUrl, 'response': response.data })
		}
	}

	async function writeOff(e) {
		e.preventDefault();

		var response = await POST('/suppliers/writeoff-debt', selectedItem, { loader: true })

		if (httpOk(response)) {
			toggleModalWriteOff(false)
			searchWithFilter()
		}
	}

	function toggleModalPayment(bool = false, item = null) {
		var itemCopy = { ...item }

		if (bool) {
			itemCopy.created_at = new Date()
			setSelectedItem(itemCopy)
		} else {
			itemCopy.amount = ''
			itemCopy.note = ""
			itemCopy.created_at = new Date()
			setSelectedItem(itemCopy)
		}

		setModalPayment(bool)
	}

	/* SVERKA FARQI — faqat qarzga tegadi (tovar/ombor/tannarxga emas).
	   Ilgari buning yo'li yo'q edi va odamlar soxta mahsulot bilan kirim yozardi. */
	function toggleModalAdjustment(bool = false, item = null) {
		if (bool) {
			setSelectedItem({ ...item, amount: '', note: '', direction: 'debt_up' })
		}
		setModalAdjustment(bool)
	}

	async function createAdjustment(e) {
		e.preventDefault()

		const response = await POST('/suppliers-adjustment', {
			supplier_id: selectedItem.supplier_id,
			amount: selectedItem.amount,
			direction: selectedItem.direction,
			note: selectedItem.note,
		}, { loader: true })

		if (httpOk(response)) {
			toggleModalAdjustment(false)
			searchWithFilter()
		}
	}

	function toggleModalWriteOff(bool = false, item = null) {
		var itemCopy = { ...item }

		if (bool) {
			itemCopy.amount = item.balance
			itemCopy.note = ""
		}

		setSelectedItem(itemCopy)
		setModalWriteOff(bool)
	}

	function resetFilter() {
		setFilterData({
			start_date: formatDate(new Date(date.getFullYear(), date.getMonth(), 1), 'yyyy-MM-dd'),
			end_date: formatDate(new Date(), 'yyyy-MM-dd'),
			search: '',
		})

		searchWithFilter()
	}

	function checkFilter() {
		if (
			filterData.search === ''
		) {
			setFilterDataExist(false)
		}
	}

	async function paginate(page, size) {
		setFilterData({ ...filterData, 'page': page, 'size': size })
	}

	useEffect(() => {
		searchWithFilter(false)
	}, [filterData.search, filterData.page, filterData.size]) // eslint-disable-line react-hooks/exhaustive-deps

	return (
		<>
			<div className="page-header">
				<h4 className="vertical-center h-100">
					{t('suppliers')} [{data.total}]
				</h4>
			</div>

			<div className="card">
				<div className="card-body">
					<div className="d-flex justify-content-between flex-wrap mb-3">
						<div className="d-flex gap-2">
							<FilterSearch
								filterData={filterData}
								setFilterData={setFilterData}>
							</FilterSearch>
						</div>
						<div className="d-flex gap-2">
							<div className="vertical-center">
								<h4><b>{t('amount')}</b>:</h4>
							</div>
							<div className="vertical-center">
								<h5 className="text-end">
									<span className={`${data.total_amount >= 0 ? 'text-success' : 'text-danger'}`}>
										{formatMoney(data.total_amount)} $
									</span>
								</h5>
							</div>
						</div>
					</div>

					{filterDataExist &&
						<div className="filter-block">
							<div className="filter">
								<strong>{t('filter')}</strong>
								<br />
								{filterData.search &&
									<span className="me-2">
										<b>{t('search')}: </b>
										<span>{filterData.search}</span>
									</span>
								}
							</div>
							<div className="vertical-center">
								<button className="btn btn-outline-dark text-uppercase" onClick={resetFilter}>
									{t('reset')}
								</button>
							</div>
						</div>
					}

					<div className="table-responsive">
						<table className="table table-bordered mb-0">
							<thead>
								<tr>
									<th style={{ 'minWidth': '33px' }} className="text-center">#</th>
									<th style={{ 'width': '20%' }}>{t('supplier')}</th>
									<th style={{ 'width': '10%' }}>{t('phone')}</th>
									<th style={{ 'width': '60%' }}></th>
									<th style={{ 'width': '10%' }} className="text-end">{t('debt')}</th>
									<th style={{ 'minWidth': '33px' }}></th>
								</tr>
							</thead>
							<tbody>
								{data?.data?.map((item, index) => (
									<tr className="tr-middle" key={index}>
										<td className="text-center">{item.row_number}</td>
										<td className="td-ellipsis">
											<Link className="text-primary cursor table-first-column-clickable"
												to={`/report-suppliers-debts/${item.supplier_id}`}>
												{item.name}
											</Link>
										</td>
										<td className="text-nowrap">{regexPhoneNumber(item.phone)}</td>
										<td></td>
										<td className="text-end text-nowrap">
											<div className={item.balance >= 0 ? 'text-success' : 'text-danger'}>
												{/* Ta'minotchi balansi $ da yuritiladi — belgisi yo'q edi, chalg'itardi */}
												<span>{formatMoney(item.balance)} $</span>
											</div>
										</td>
										<td>
											<div className="table-dropdown">
												<Dropdown id={`dropdown-${index}`}>
													<Dropdown.Toggle variant="outline-primary">
														<i className="uil uil-ellipsis-v"></i>
													</Dropdown.Toggle>

													<Dropdown.Menu>
														<div className="table-dropdown-item"
															onClick={() => toggleModalPayment(true, item)}>
															<i className="uil uil-transaction"></i>
															{t('payment')}
														</div>
														{canAdjust &&
															<div className="table-dropdown-item"
																onClick={() => toggleModalAdjustment(true, item)}>
																<i className="uil uil-balance-scale"></i>
																{t('supplier_adjustment')}
															</div>
														}
														<Link to={`/report-suppliers-debts/${item.supplier_id}`}
															className="table-dropdown-item">
															<i className="uil-eye"></i>
															{t('supplier_card')}
														</Link>
														{/* PAST-13: "Qarzni o'chirish" YASHIRILDI — backend /suppliers/writeoff-debt route'i
														    mavjud emas (404, hech narsa qilmaydi). Funksiya kerak bo'lsa avval backend yozilsin. */}
													</Dropdown.Menu>
												</Dropdown>
											</div>
										</td>
									</tr>
								))}
							</tbody>
						</table>
					</div>

					{pagination.response &&
						<FilterPagination
							pagination={pagination}
							paginate={paginate}>
						</FilterPagination>
					}
				</div>
			</div>

			<PaymentModal
				modalExpense={modalPayment}
				toggleModal={toggleModalPayment}
				searchWithFilter={searchWithFilter}
				counterparty="suppliers"
				counterparty_id={selectedItem.supplier_id} />

			{/* MODAL ADJUSTMENT — sverka farqi */}
			<Modal show={modalAdjustment} animation={false} centered
				dialogClassName="update-modal-width" backdrop="static"
				onHide={() => toggleModalAdjustment(false)}>
				<Modal.Header closeButton>
					<Modal.Title>{t('supplier_adjustment_add')}</Modal.Title>
				</Modal.Header>
				<Modal.Body>
					<form onSubmit={createAdjustment} autoComplete="off">
						<div className="d-flex justify-content-between mb-3">
							<div>
								<div className="text-muted fz-14">{t('supplier')}</div>
								<b>{selectedItem.name}</b>
							</div>
							<div className="text-end">
								<div className="text-muted fz-14">{t('current_debt')}</div>
								<b className={selectedItem.balance >= 0 ? 'text-success' : 'text-danger'}>
									{formatMoney(selectedItem.balance)} $
								</b>
							</div>
						</div>

						<div className="form-group">
							<label>{t('type')}<span className="required-mark">*</span></label>
							<div className="d-flex gap-2">
								<button type="button"
									className={`btn w-100 ${selectedItem.direction === 'debt_up' ? 'btn-danger' : 'btn-outline-danger'}`}
									onClick={() => setSelectedItem({ ...selectedItem, 'direction': 'debt_up' })}>
									{t('debt_increase')}
								</button>
								<button type="button"
									className={`btn w-100 ${selectedItem.direction === 'debt_down' ? 'btn-success' : 'btn-outline-success'}`}
									onClick={() => setSelectedItem({ ...selectedItem, 'direction': 'debt_down' })}>
									{t('debt_decrease')}
								</button>
							</div>
						</div>

						<div className="form-group">
							<label>{t('amount')} ($)<span className="required-mark">*</span></label>
							<input type="number" step="0.01" min="0.01" className="form-control" autoFocus
								value={selectedItem.amount ?? ''}
								onChange={(e) => setSelectedItem({ ...selectedItem, 'amount': e.target.value })} />
						</div>

						<div className="form-group">
							<label>{t('reason')}<span className="required-mark">*</span></label>
							<input type="text" className="form-control" maxLength="255"
								value={selectedItem.note ?? ''}
								onChange={(e) => setSelectedItem({ ...selectedItem, 'note': e.target.value })} />
						</div>

						<div className="text-muted fz-14">{t('supplier_adjustment_hint')}</div>

						<div className="d-flex gap-2 w-100 mt-3">
							<button type="button" className="btn btn-outline-warning w-100"
								onClick={() => toggleModalAdjustment(false)} tabIndex="-1">
								{t('cancel')}
							</button>
							<button type="submit" className="btn btn-primary w-100"
								disabled={!selectedItem.amount || Number(selectedItem.amount) <= 0 || !selectedItem.note}>
								{t('save')}
							</button>
						</div>
					</form>
				</Modal.Body>
			</Modal>
			{/* MODAL ADJUSTMENT */}

			{/* MODAL WRITE OFF */}
			<Modal show={modalWriteOff} animation={false} centered
				dialogClassName="update-modal-width" backdrop="static"
				onHide={() => toggleModalWriteOff(false)}>
				<Modal.Header closeButton>
					<Modal.Title>{t('write_off_debt')}</Modal.Title>
				</Modal.Header>
				<Modal.Body>
					<form onSubmit={writeOff} autoComplete="off">
						<div className="form-group">
							<label>{t('amount')}<span className="required-mark">*</span></label>
							<input type="text" className="form-control" name="amount" autoFocus
								value={selectedItem.amount ? formatMoney(selectedItem.amount) : ''}
								disabled />
						</div>
						<div className="form-group">
							<label>{t('note')}</label>
							<input type="text" className="form-control" name="note"
								onChange={(e) => setSelectedItem({ ...selectedItem, 'note': e.target.value })} />
						</div>
						<div className="d-flex gap-2 w-100 mt-3">
							<button type="button" className="btn btn-outline-warning w-100"
								onClick={() => toggleModalWriteOff(false)} tabIndex="-1">
								{t('cancel')}
							</button>
							<button type="submit" className="btn btn-primary w-100">
								{t('save')}
							</button>
						</div>
					</form>
				</Modal.Body>
			</Modal>
			{/* MODAL WRITE OFF */}
		</>
	)
}

export default Index
